import { onUnmounted, watch } from 'vue'
import { useRoute } from 'vue-router'

const ROUTE_CLASS_PREFIX = 'route-'

function toBodyRouteClass(routeName: string | symbol | null | undefined): string | null {
  if (routeName == null || typeof routeName !== 'string' || !routeName) return null
  return `${ROUTE_CLASS_PREFIX}${routeName}`
}

/** 将当前路由 name 同步为 body 上的 class，便于全局 CSS 按路由控制样式 */
export function useBodyRouteClass() {
  const route = useRoute()
  let currentClass: string | null = null

  const sync = (routeName: string | symbol | null | undefined) => {
    const nextClass = toBodyRouteClass(routeName)
    if (currentClass) {
      document.body.classList.remove(currentClass)
    }
    currentClass = nextClass
    if (currentClass) {
      document.body.classList.add(currentClass)
    }
  }

  watch(() => route.name, sync, { immediate: true })

  onUnmounted(() => {
    if (currentClass) {
      document.body.classList.remove(currentClass)
    }
  })
}
